
// ================= PDP DYNAMIC BODY MEASUREMENT SPEC SYSTEM =================
window.updatePdpDynamicSpecBadge = function(sizeVal) {
  var badge = document.getElementById('dynamicSizeSpecsBadge');
  var specsText = document.getElementById('dynamicSizeSpecsText');
  if (!badge || !specsText) return;

  var isBottom = badge.getAttribute('data-is-bottom') === 'true';
  var path = (window.location.pathname || '').toLowerCase();
  var title = (document.title || '').toLowerCase();
  if (path.includes('pant') || path.includes('trouser') || path.includes('jogger') || path.includes('short') || path.includes('bottom') || path.includes('legging') || path.includes('cargo') || path.includes('jean') || path.includes('palazzo') ||
      title.includes('pant') || title.includes('trouser') || title.includes('jogger') || title.includes('short') || title.includes('bottom') || title.includes('cargo') || title.includes('jean')) {
    isBottom = true;
  }

  var rawSize = (sizeVal || '').toString().trim().toUpperCase();
  var sizeKey = rawSize;
  if (rawSize.includes('(')) {
    var m = rawSize.match(/^([^\(]+)/);
    if (m) sizeKey = m[1].trim();
  }
  // Remove trailing quotes or spaces
  sizeKey = sizeKey.replace(/["']/g, '').trim();

  if (isBottom) {
    var bottomMap = {
      'XS': { waist: '26–28"', hip: '36"', length: '38"', inseam: '28"' },
      'S': { waist: '28–30"', hip: '38"', length: '39"', inseam: '28.5"' },
      'M': { waist: '30–32"', hip: '40"', length: '40"', inseam: '29"' },
      'L': { waist: '32–34"', hip: '42"', length: '41"', inseam: '29.5"' },
      'XL': { waist: '34–36"', hip: '44"', length: '41.5"', inseam: '30"' },
      'XXL': { waist: '36–38"', hip: '46"', length: '42"', inseam: '30.5"' },
      '2XL': { waist: '36–38"', hip: '46"', length: '42"', inseam: '30.5"' },
      '3XL': { waist: '38–40"', hip: '48"', length: '42.5"', inseam: '31"' },
      '4XL': { waist: '40–42"', hip: '50"', length: '43"', inseam: '31"' },
      '26': { waist: '26"', hip: '34"', length: '37.5"', inseam: '28"' },
      '28': { waist: '28"', hip: '36"', length: '38.5"', inseam: '28.5"' },
      '30': { waist: '30"', hip: '38"', length: '39.5"', inseam: '29"' },
      '32': { waist: '32"', hip: '40"', length: '40.5"', inseam: '29.5"' },
      '34': { waist: '34"', hip: '42"', length: '41.5"', inseam: '30"' },
      '36': { waist: '36"', hip: '44"', length: '42"', inseam: '30.5"' },
      '38': { waist: '38"', hip: '46"', length: '42.5"', inseam: '31"' },
      '40': { waist: '40"', hip: '48"', length: '43"', inseam: '31"' },
      'FREE SIZE': { waist: '28–34"', hip: '40–44"', length: '40"', inseam: '29"' },
      'STANDARD': { waist: '30–32"', hip: '40"', length: '40"', inseam: '29"' }
    };
    var specs = bottomMap[sizeKey] || bottomMap['M'];
    specsText.innerHTML = '<b>To Fit Body:</b> ' +
      '<span class="spec-label">Waist:</span> <b class="spec-val">' + specs.waist + '</b> <span class="spec-sep">|</span> ' +
      '<span class="spec-label">Hip:</span> <b class="spec-val">' + specs.hip + '</b> <span class="spec-sep">|</span> ' +
      '<span class="spec-label">Length:</span> <b class="spec-val">' + specs.length + '</b> <span class="spec-sep">|</span> ' +
      '<span class="spec-label">Inseam:</span> <b class="spec-val">' + specs.inseam + '</b>';
  } else {
    var topMap = {
      'XS': { chest: '36"', shoulder: '15.5"', length: '26"', sleeve: '7.5"' },
      'S': { chest: '38"', shoulder: '16.5"', length: '27"', sleeve: '8.0"' },
      'M': { chest: '40"', shoulder: '17.5"', length: '28"', sleeve: '8.5"' },
      'L': { chest: '42"', shoulder: '18.5"', length: '29"', sleeve: '9.0"' },
      'XL': { chest: '44"', shoulder: '19.5"', length: '30"', sleeve: '9.5"' },
      'XXL': { chest: '46"', shoulder: '20.5"', length: '31"', sleeve: '10.0"' },
      '2XL': { chest: '46"', shoulder: '20.5"', length: '31"', sleeve: '10.0"' },
      '3XL': { chest: '48"', shoulder: '21.5"', length: '32"', sleeve: '10.5"' },
      '4XL': { chest: '50"', shoulder: '22.5"', length: '33"', sleeve: '11.0"' },
      '5XL': { chest: '52"', shoulder: '23.5"', length: '34"', sleeve: '11.5"' },
      '36': { chest: '36"', shoulder: '15.5"', length: '26"', sleeve: '7.5"' },
      '38': { chest: '38"', shoulder: '16.5"', length: '27"', sleeve: '8.0"' },
      '40': { chest: '40"', shoulder: '17.5"', length: '28"', sleeve: '8.5"' },
      '42': { chest: '42"', shoulder: '18.5"', length: '29"', sleeve: '9.0"' },
      '44': { chest: '44"', shoulder: '19.5"', length: '30"', sleeve: '9.5"' },
      '46': { chest: '46"', shoulder: '20.5"', length: '31"', sleeve: '10.0"' },
      'FREE SIZE': { chest: '40–42"', shoulder: '18"', length: '28"', sleeve: '8.5"' },
      'STANDARD': { chest: '40"', shoulder: '17.5"', length: '28"', sleeve: '8.5"' }
    };
    var specs = topMap[sizeKey] || topMap['M'];
    specsText.innerHTML = '<b>To Fit Body:</b> ' +
      '<span class="spec-label">Chest:</span> <b class="spec-val">' + specs.chest + '</b> <span class="spec-sep">|</span> ' +
      '<span class="spec-label">Shoulder:</span> <b class="spec-val">' + specs.shoulder + '</b> <span class="spec-sep">|</span> ' +
      '<span class="spec-label">Length:</span> <b class="spec-val">' + specs.length + '</b> <span class="spec-sep">|</span> ' +
      '<span class="spec-label">Sleeve:</span> <b class="spec-val">' + specs.sleeve + '</b>';
  }

  var stickySize = document.getElementById('stickySelectedSize');
  if (stickySize && rawSize) {
    stickySize.textContent = rawSize;
  }
};


// ================= GLOBAL CURRENCY & MONEY FORMATTER =================
window.Shopify = window.Shopify || {};
window.Shopify.money_format = window.Shopify.money_format || '₹{{amount}}';

window.formatMoney = function(cents, format) {
  if (cents === null || cents === undefined || cents === '') return '₹0.00';
  
  var val = typeof cents === 'string' ? parseFloat(cents.replace(/[^0-9.-]+/g, '')) : parseFloat(cents);
  if (isNaN(val)) return '₹0.00';

  // Currency conversion support
  var currency = (window.TFI && window.TFI.currency) || 'INR';
  var rate = (window.TFI && window.TFI.currencyRate) || 1.0;
  var symbol = (window.TFI && window.TFI.currencySymbol) || '₹';

  // If cents is passed as integer cents (> 5000 and not decimal), divide by 100
  if (val > 1000 && Number.isInteger(val)) {
    val = val / 100.0;
  }

  var converted = val * rate;
  return symbol + converted.toLocaleString('en-IN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
};

window.Shopify.formatMoney = window.formatMoney;

/**
 * TSHIRT FACTORY INDIA — MASTER SUITE 2026 (v4.0 CONSOLIDATED)
 * Direct Garment Manufacturer Surat · Enterprise OS 2.0
 * 100% Zero-Error All Global Functions
 */

window.TFI = window.TFI || {
  currency: 'INR',
  currencyRate: 1.0,
  currencySymbol: '₹',
  selectedSingleVariantId: null,
  selectedSingleVariantTitle: 'Standard',
  currentPlacement: 'Left Chest (Pocket)',
  posX: 28,
  posY: 28,
  scale: 100,
  rotation: 0,
  currentArtworkUrl: null,
  currentArtworkName: null,
  currentCustomText: ''
};

// ================= 1. HOMEPAGE CATALOG & TAB FILTERING =================
window.switchCatalogTab = function(tabId, btn) {
  if (!tabId) return;

  // 1. Universal Hide: Hide ALL possible catalog panels completely
  var allPanels = document.querySelectorAll('.catalog-grid-panel, .catalog-slider-panel, [id^="tab-"]');
  allPanels.forEach(function(p) {
    p.classList.remove('active');
    p.style.setProperty('display', 'none', 'important');
    p.style.setProperty('visibility', 'hidden', 'important');
    p.style.setProperty('height', '0', 'important');
    p.style.setProperty('opacity', '0', 'important');
  });

  // 2. Show ONLY the requested panel
  var target = document.getElementById('tab-' + tabId);
  if (target) {
    target.classList.add('active');
    target.style.setProperty('display', 'block', 'important');
    target.style.setProperty('visibility', 'visible', 'important');
    target.style.setProperty('height', 'auto', 'important');
    target.style.setProperty('opacity', '1', 'important');
  }

  // 3. Update tab buttons
  var allBtns = document.querySelectorAll('.cft-tab, .cat-pill, .tfi-cat-pill, .cmd-item');
  allBtns.forEach(function(b) {
    if (b.getAttribute('data-tab') === tabId) {
      b.classList.add('active');
    } else {
      b.classList.remove('active');
    }
  });

  // 4. Update mobile labels
  var curName = document.getElementById('cmdCurrentName');
  var curIcon = document.getElementById('cmdCurrentIcon');
  if (tabId === 'men') {
    if (curName) curName.textContent = "Men's Collection Only";
    if (curIcon) curIcon.textContent = '👔';
  } else if (tabId === 'women') {
    if (curName) curName.textContent = "Women's Collection Only";
    if (curIcon) curIcon.textContent = '👗';
  } else if (tabId === 'kids') {
    if (curName) curName.textContent = "Kids Wear Only";
    if (curIcon) curIcon.textContent = '👶';
  } else if (tabId === 'bestsellers') {
    if (curName) curName.textContent = 'Top Bestsellers';
    if (curIcon) curIcon.textContent = '★';
  }

  // 5. Smooth scroll to top of collection
  var targetAnchor = document.getElementById('catalogFilterTabContainer') || document.getElementById('featuredCatalogSection');
  if (targetAnchor) {
    var rect = targetAnchor.getBoundingClientRect();
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    var targetY = rect.top + scrollTop - 80;
    if (rect.top < 60 || rect.top > 250) {
      window.scrollTo({
        top: Math.max(0, targetY),
        behavior: 'smooth'
      });
    }
  }
};

window.filterSelection = function(category) {
  var faqItems = document.querySelectorAll('.faq-item');
  var btns = document.querySelectorAll('.faq-filter-btn');
  btns.forEach(function(b) { b.classList.remove('active'); });
  if (event && event.currentTarget) event.currentTarget.classList.add('active');
  faqItems.forEach(function(item) {
    if (category === 'all' || item.classList.contains(category)) {
      item.style.display = 'block';
    } else {
      item.style.display = 'none';
    }
  });
};

// ================= 2. PDP MAIN IMAGE & THUMBNAIL CONTROLLER =================
window.setMainImage = function(src, btn) {
  var mainImg = document.getElementById('mainProductImg') || document.getElementById('mainGarmentImg');
  if (mainImg) {
    mainImg.src = src;
    mainImg.srcset = '';
  }
  var allThumbs = document.querySelectorAll('.thumb-btn, .pdp-thumb');
  allThumbs.forEach(function(t) { t.classList.remove('active'); });
  if (btn) btn.classList.add('active');

  // If thumbnail has color association, sync color swatch button
  if (btn) {
    var thColor = (btn.getAttribute('data-img-color') || '').toLowerCase().trim();
    if (thColor) {
      var colorBtns = document.querySelectorAll('.pdp-option-color-group .color-pill-btn, #colorSelectorGrid .color-pill-btn');
      colorBtns.forEach(function(cb) {
        var cbVal = (cb.getAttribute('data-option-value') || cb.innerText || '').toLowerCase().trim();
        if (cbVal === thColor && !cb.classList.contains('selected')) {
          cb.click();
        }
      });
    }
  }
};

window.scrollThumbnails = function(direction) {
  var track = document.getElementById('pdpThumbTrack');
  if (track) {
    track.scrollBy({ left: direction * 150, behavior: 'smooth' });
    setTimeout(function() {
      if (window.checkThumbArrows) window.checkThumbArrows();
    }, 250);
  }
};

window.checkThumbArrows = function() {
  var track = document.getElementById('pdpThumbTrack');
  var prev = document.getElementById('thumbPrevBtn');
  var next = document.getElementById('thumbNextBtn');
  if (!track || !prev || !next) return;

  var wrap = track.closest('.pdp-thumbs-slider-wrap');
  var thumbs = track.querySelectorAll('.thumb-btn:not([style*="display: none"])');
  var count = thumbs.length;
  var w = window.innerWidth;

  // Thresholds:
  // Desktop (>1024px): only show when more than 5 thumbnails (>5)
  // Tablet (768px-1024px): only show when more than 4 thumbnails (>4)
  // Mobile (<768px): only show when more than 3 thumbnails (>3)
  var minThumbs = 5;
  if (w < 768) {
    minThumbs = 3;
  } else if (w <= 1024) {
    minThumbs = 4;
  }

  if (wrap) wrap.setAttribute('data-thumb-count', count);

  // If count is less than or equal to threshold, or no overflow: ALWAYS hide
  if (count <= minThumbs || track.scrollWidth <= (track.clientWidth + 5)) {
    prev.style.display = 'none';
    next.style.display = 'none';
    return;
  }

  // Overflowing with > threshold images:
  var scrollLeft = track.scrollLeft;
  var maxScroll = track.scrollWidth - track.clientWidth;
  prev.style.display = scrollLeft > 8 ? 'flex' : 'none';
  next.style.display = scrollLeft < (maxScroll - 8) ? 'flex' : 'none';
};

// ================= 3. PDP MULTI-OPTION & VARIANT SELECTOR CONTROLLER =================
window.selectPdpOption = function(btn, optionIndex, value) {
  var group = btn.closest('.pdp-option-group');
  if (group) {
    var buttons = group.querySelectorAll('button');
    buttons.forEach(function(b) { b.classList.remove('selected'); });
    btn.classList.add('selected');
  }

  var colorLabel = document.getElementById('selectedColorLabel');
  var sizeLabel = document.getElementById('selectedSizeLabel');
  
  var selectedOptions = [];
  var allGroups = document.querySelectorAll('.pdp-option-group');
  allGroups.forEach(function(g, idx) {
    var activeBtn = g.querySelector('button.selected');
    if (activeBtn) {
      var val = activeBtn.getAttribute('data-option-value') || activeBtn.innerText.trim();
      selectedOptions[idx] = val;
      var optType = g.getAttribute('data-option-type') || '';
      if (optType === 'color' || idx === 0) {
        if (colorLabel) colorLabel.textContent = val;
      }
      if (optType === 'size' || (!optType && idx > 0)) {
        if (sizeLabel) sizeLabel.textContent = val;
        window.updatePdpDynamicSpecBadge(val);
      }
    }
  });

  var jsonEl = document.getElementById('pdpProductJson');
  if (!jsonEl) return;
  try {
    var productData = JSON.parse(jsonEl.textContent);
    var matchingVariant = productData.variants.find(function(v) {
      return v.options.every(function(optVal, optIdx) {
        return !selectedOptions[optIdx] || optVal.toLowerCase() === selectedOptions[optIdx].toLowerCase();
      });
    });

    var atcBtn = document.getElementById('btnSingleAddToCart') || document.querySelector('.pdp-btn-atc');
    var qtyInput = document.getElementById('singleQtyInput');
    var qtyStepper = document.querySelector('.stepper-single');

    if (matchingVariant) {
      window.TFI.selectedSingleVariantId = matchingVariant.id;
      window.TFI.selectedSingleVariantTitle = matchingVariant.title;
      window.selectedVariantId = matchingVariant.id;
      
      var priceEl = document.getElementById('displayBasePrice') || document.getElementById('b2cLivePrice') || document.querySelector('.pdp-price');
      if (priceEl) {
        priceEl.textContent = '₹' + (matchingVariant.price / 100).toFixed(2);
      }

      // 1. Switch Main Hero Image to this Variant's Image or Button Image
      var btnImg = btn.getAttribute('data-variant-img');
      var targetImgSrc = (matchingVariant && matchingVariant.featured_image && matchingVariant.featured_image.src) 
        ? matchingVariant.featured_image.src 
        : (btnImg || null);

      if (targetImgSrc) {
        var mainImg = document.getElementById('mainProductImg') || document.getElementById('mainGarmentImg');
        if (mainImg) {
          mainImg.src = targetImgSrc;
          mainImg.srcset = '';
        }
      }

      // 2. Highlight and Scroll Thumbnail Track to Selected Color
      var activeColorVal = (selectedOptions[0] || '').toLowerCase().trim();
      var allThumbs = document.querySelectorAll('#pdpThumbTrack .thumb-btn');
      var matchingThumb = null;
      allThumbs.forEach(function(th) {
        var thColor = (th.getAttribute('data-img-color') || '').toLowerCase().trim();
        var thUrl = th.getAttribute('data-img-url') || '';
        if (activeColorVal && thColor && thColor === activeColorVal) {
          if (!matchingThumb) matchingThumb = th;
        } else if (targetImgSrc && thUrl && targetImgSrc.indexOf(thUrl.split('?')[0].split('/').pop()) !== -1) {
          if (!matchingThumb) matchingThumb = th;
        }
      });
      if (matchingThumb) {
        allThumbs.forEach(function(t) { t.classList.remove('active'); });
        matchingThumb.classList.add('active');
        matchingThumb.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      }

      // 3. Dynamic WhatsApp Order Link
      var currentValColor = colorLabel ? colorLabel.textContent.trim() : (selectedOptions[0] || '');
      var currentValSize = sizeLabel ? sizeLabel.textContent.trim() : (selectedOptions[1] || '');
      var currentQty = qtyInput ? (qtyInput.value || '1') : '1';
      var prodTitleEl = document.querySelector('.pdp-title');
      var pTitle = prodTitleEl ? prodTitleEl.textContent.trim() : 'Product';
      var waMsg = 'Hi Tshirt Factory India, I want to order "' + pTitle + '" - Color: ' + currentValColor + ', Size: ' + currentValSize + ', Qty: ' + currentQty + '. Please share invoice & payment link.';
      var waUrl = 'https://wa.me/918320610394?text=' + encodeURIComponent(waMsg);
      var b2cWaBtn = document.getElementById('b2cWaBtn');
      if (b2cWaBtn) b2cWaBtn.href = waUrl;
      var stickyWaBtn = document.getElementById('stickyWaBtn');
      if (stickyWaBtn) stickyWaBtn.href = waUrl;

      var varInput = document.getElementById('singleVariantId');
      if (varInput) varInput.value = matchingVariant.id;

      // Real-time In Stock vs Sold Out Handling
      if (matchingVariant.available === false) {
        if (atcBtn) {
          atcBtn.textContent = 'SOLD OUT';
          atcBtn.disabled = true;
          atcBtn.classList.add('sold-out');
        }
        if (qtyInput) qtyInput.disabled = true;
        if (qtyStepper) qtyStepper.style.opacity = '0.5';
      } else {
        if (atcBtn) {
          atcBtn.textContent = 'Add to Cart →';
          atcBtn.disabled = false;
          atcBtn.classList.remove('sold-out');
        }
        if (qtyInput) qtyInput.disabled = false;
        if (qtyStepper) qtyStepper.style.opacity = '1';
      }
    } else {
      if (atcBtn) {
        atcBtn.textContent = 'UNAVAILABLE';
        atcBtn.disabled = true;
        atcBtn.classList.add('sold-out');
      }
    }

    // Dynamic Sold-out styling on cross-options (Sizes for selected Color)
    if (selectedOptions[0]) {
      var sizeBtns = document.querySelectorAll('#sizeSelectorGrid button, .pdp-option-group[data-option-type="size"] button');
      sizeBtns.forEach(function(sBtn) {
        var sVal = sBtn.getAttribute('data-option-value') || sBtn.innerText.trim();
        var vMatch = productData.variants.find(function(v) {
          return v.options[0].toLowerCase() === selectedOptions[0].toLowerCase() && v.options[1].toLowerCase() === sVal.toLowerCase();
        });
        if (vMatch && vMatch.available === false) {
          sBtn.classList.add('option-sold-out');
        } else {
          sBtn.classList.remove('option-sold-out');
        }
      });
    }

  } catch (e) {
    console.error('Error matching variant:', e);
  }
};

window.selectB2CSize = function(btn) {
  var allPills = document.querySelectorAll('#b2cSizeSelector .size-pill');
  allPills.forEach(function(p) { p.classList.remove('selected'); });
  btn.classList.add('selected');
  
  var varId = btn.getAttribute('data-variant-id');
  var title = btn.getAttribute('data-variant-title');
  var isAvail = btn.getAttribute('data-available') === 'true';

  window.TFI.selectedSingleVariantId = varId;
  window.TFI.selectedSingleVariantTitle = title;
  window.selectedVariantId = varId;
  
  var sizeLabel = document.getElementById('selectedSizeLabel');
  if (sizeLabel && title) { sizeLabel.textContent = title; window.updatePdpDynamicSpecBadge(title); }
  var stickySize = document.getElementById('stickySelectedSize');
  if (stickySize && title) stickySize.textContent = title;
  if (typeof window.updatePdpWaUrl === 'function') window.updatePdpWaUrl(title);
  
  var varInput = document.getElementById('singleVariantId');
  if (varInput && varId) varInput.value = varId;

  var atcBtn = document.getElementById('btnSingleAddToCart') || document.querySelector('.pdp-btn-atc');
  var qtyInput = document.getElementById('singleQtyInput');
  var qtyStepper = document.querySelector('.stepper-single');

  if (!isAvail) {
    if (atcBtn) {
      atcBtn.textContent = 'SOLD OUT';
      atcBtn.disabled = true;
      atcBtn.classList.add('sold-out');
    }
    if (qtyInput) qtyInput.disabled = true;
    if (qtyStepper) qtyStepper.style.opacity = '0.5';
  } else {
    if (atcBtn) {
      atcBtn.textContent = 'Add to Cart →';
      atcBtn.disabled = false;
      atcBtn.classList.remove('sold-out');
    }
    if (qtyInput) qtyInput.disabled = false;
    if (qtyStepper) qtyStepper.style.opacity = '1';
  }
};

// PDP STEPPERS & ACCORDIONS
window.stepSingleQty = function(delta) {
  var input = document.getElementById('singleQtyInput');
  if (!input) return;
  var cur = parseInt(input.value, 10) || 1;
  var next = Math.max(1, Math.min(99, cur + delta));
  input.value = next;
};

window.validateSingleQty = function(input) {
  var val = parseInt(input.value, 10) || 1;
  input.value = Math.max(1, Math.min(99, val));
};

window.stepQty = function(variantId, delta) {
  var input = document.getElementById('qty-' + variantId);
  if (!input) return;
  var cur = parseInt(input.value, 10) || 0;
  var next = Math.max(0, cur + delta);
  input.value = next;
  window.recalcBulkTotal();
};

window.applyPreset = function(distribution) {
  var inputs = document.querySelectorAll('.size-qty-input');
  inputs.forEach(function(inp, idx) {
    inp.value = distribution[idx] !== undefined ? distribution[idx] : 0;
  });
  window.recalcBulkTotal();
};

window.recalcBulkTotal = function() {
  var inputs = document.querySelectorAll('.size-qty-input');
  var totalQty = 0;
  inputs.forEach(function(inp) {
    totalQty += parseInt(inp.value, 10) || 0;
  });
  var qtyDisplay = document.getElementById('bulkTotalQty');
  if (qtyDisplay) qtyDisplay.textContent = totalQty + ' Pcs';
};

window.handleBulkAddToCart = function() {
  var inputs = document.querySelectorAll('.size-qty-input');
  var items = [];
  inputs.forEach(function(inp) {
    var qty = parseInt(inp.value, 10) || 0;
    if (qty > 0) {
      items.push({
        id: parseInt(inp.getAttribute('data-variant-id'), 10),
        quantity: qty,
        properties: { 'Purchase Type': 'B2B Wholesale' }
      });
    }
  });

  if (items.length === 0) {
    alert('Please enter quantity for at least one size.');
    return;
  }

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: items })
  })
  .then(function(res) { return res.json(); })
  .then(function() {
    if (typeof updateCartDrawer === 'function') updateCartDrawer();
    window.openCart();
  })
  .catch(function(err) { console.error('Bulk cart add error:', err); });
};


// ================= MASTER STOREWIDE EXCLUSIVE ACCORDION CONTROLLER =================
// When any accordion item is opened, all other items in the same container automatically close
window.toggleAccordion = function(headerOrItem, e) {
  if (e && typeof e.stopPropagation === 'function') {
    e.stopPropagation();
  }
  if (!headerOrItem) return;

  var item = headerOrItem.classList.contains('spec-acc-item') || 
             headerOrItem.classList.contains('accordion-item') || 
             headerOrItem.classList.contains('pdp-accordion-item') ||
             headerOrItem.classList.contains('faq-item') ||
             headerOrItem.classList.contains('tfi-faq-item') ||
             headerOrItem.classList.contains('filterDiv')
    ? headerOrItem 
    : headerOrItem.closest('.spec-acc-item, .accordion-item, .pdp-accordion-item, .faq-item, .tfi-faq-item, .filterDiv, .tfi-mob-acc, details');

  if (!item) return;

  var isOpen = item.classList.contains('active') || item.classList.contains('open') || item.hasAttribute('open');

  // Find parent container to close all other sibling accordions in the same group
  var container = item.closest('.pdp-specs-accordion-wrap, .spec-accordion-container, .accordion-wrap, .accordion-container, .faq-accordion, .faq-list, .faq-wrap, .faq_wrappers, .main_faq_wrapper, .tfi-mob-body') || item.parentElement;

  if (container) {
    var siblings = container.querySelectorAll('.spec-acc-item, .accordion-item, .pdp-accordion-item, .faq-item, .tfi-faq-item, .filterDiv, .tfi-mob-acc, details');
    siblings.forEach(function(sib) {
      if (sib !== item) {
        sib.classList.remove('active', 'open');
        sib.removeAttribute('open');
        var sibBody = sib.querySelector('.spec-acc-body, .accordion-body, .faq-answer, .accordion-panel, .pdp-custom-body-content, .tfi-mob-acc-panel');
        if (sibBody) {
          sibBody.style.display = 'none';
        }
        var sibIcon = sib.querySelector('.spec-acc-icon, .accordion-icon, .faq-icon');
        if (sibIcon) {
          sibIcon.textContent = '+';
        }
      }
    });
  }

  // Toggle the clicked item
  var body = item.querySelector('.spec-acc-body, .accordion-body, .faq-answer, .accordion-panel, .tfi-mob-acc-panel');
  var icon = item.querySelector('.spec-acc-icon, .accordion-icon, .faq-icon');

  if (isOpen) {
    item.classList.remove('active', 'open');
    item.removeAttribute('open');
    if (body) body.style.display = 'none';
    if (icon) icon.textContent = '+';
  } else {
    item.classList.add('active', 'open');
    if (item.tagName === 'DETAILS') item.setAttribute('open', '');
    if (body) body.style.display = 'block';
    if (icon) icon.textContent = '−';
  }
};
window.tfiToggleSpecAccordion = window.toggleAccordion;

// Global automated click delegation for all FAQs, details & accordion headers
document.addEventListener('click', function(e) {
  var trigger = e.target.closest('.spec-acc-head, .accordion-head, .faq-head, .faq-question, .accordion-thumb, summary');
  if (!trigger) return;

  var item = trigger.closest('.spec-acc-item, .accordion-item, .pdp-accordion-item, .faq-item, .tfi-faq-item, .filterDiv, details');
  if (item) {
    window.toggleAccordion(item, e);
  }
});


window.checkPincodeDelivery = function() {
  var pinInput = document.getElementById('pincodeInput') || document.querySelector('.pdp-pincode-input');
  var resEl = document.getElementById('pincodeResult') || document.querySelector('.pdp-pincode-result');
  if (!pinInput || !resEl) return;
  var val = pinInput.value.trim();
  if (val.length === 6 && /^\d+$/.test(val)) {
    resEl.innerHTML = '<span style="color:#2E7D32">✔ Express Dispatch Available to ' + val + ' (Delivery in 2-4 Days via Bluedart)</span>';
  } else {
    resEl.innerHTML = '<span style="color:#C62828">⚠️ Please enter a valid 6-digit Indian PIN Code</span>';
  }
};

// ================= 4. ADD TO CART & CART DRAWER =================
window.handleSingleAddToCart = function() {
  var targetVariantId = window.TFI.selectedSingleVariantId || window.selectedVariantId;
  var varInput = document.getElementById('singleVariantId');
  if (!targetVariantId && varInput && varInput.value) {
    targetVariantId = parseInt(varInput.value, 10);
  }

  if (!targetVariantId) {
    var firstColor = document.querySelector('#colorSelectorGrid button.selected') || document.querySelector('#colorSelectorGrid button');
    var firstSize = document.querySelector('#sizeSelectorGrid button.selected') || document.querySelector('#sizeSelectorGrid button');
    if (firstColor && firstSize) {
      firstColor.classList.add('selected');
      firstSize.classList.add('selected');
      window.selectPdpOption(firstColor, 0, firstColor.getAttribute('data-option-value') || firstColor.innerText.trim());
      targetVariantId = window.TFI.selectedSingleVariantId || window.selectedVariantId;
    }
  }

  if (!targetVariantId) {
    var firstPill = document.querySelector('#b2cSizeSelector .size-pill:not(.sold-out)') || document.querySelector('#b2cSizeSelector .size-pill');
    if (firstPill) {
      window.selectB2CSize(firstPill);
      targetVariantId = window.TFI.selectedSingleVariantId;
    }
  }

  if (!targetVariantId) {
    var jsonEl = document.getElementById('pdpProductJson');
    if (jsonEl) {
      try {
        var pData = JSON.parse(jsonEl.textContent);
        if (pData && pData.variants && pData.variants.length > 0) {
          targetVariantId = pData.variants[0].id;
          window.TFI.selectedSingleVariantId = targetVariantId;
          window.TFI.selectedSingleVariantTitle = pData.variants[0].title;
        }
      } catch (e) {}
    }
  }

  if (!targetVariantId) {
    alert('Please select a size and color before adding to cart.');
    return;
  }

  var qtyInput = document.getElementById('singleQtyInput');
  var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
  var btn = document.getElementById('btnSingleAddToCart');
  if (btn) {
    btn.textContent = 'Adding to Cart...';
    btn.disabled = true;
  }

  var item = {
    id: parseInt(targetVariantId, 10),
    quantity: qty,
    properties: {
      'Purchase Type': 'Single Piece Retail',
      'Selected Garment': window.TFI.selectedSingleVariantTitle || 'Standard'
    }
  };

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [item] })
  })
  .then(function(res) { return res.json(); })
  .then(function() {
    if (btn) {
      btn.textContent = '✔ Added to Cart!';
      setTimeout(function() {
        btn.textContent = 'Add to Cart →';
        btn.disabled = false;
      }, 2000);
    }
    if (typeof updateCartDrawer === 'function') updateCartDrawer();
    window.openCart();
  })
  .catch(function(err) {
    console.error('Cart add error:', err);
    if (btn) {
      btn.textContent = '🛒 Add to Cart';
      btn.disabled = false;
    }
  });
};

// ================= DIRECT 1-TAP BUY NOW CONTROLLER =================
window.handleDirectBuyNow = function() {
  var targetVariantId = (window.TFI && window.TFI.selectedSingleVariantId) || window.selectedVariantId;
  var varInput = document.getElementById('singleVariantId');
  if (!targetVariantId && varInput && varInput.value) {
    targetVariantId = parseInt(varInput.value, 10);
  }

  if (!targetVariantId) {
    var firstPill = document.querySelector('#b2cSizeSelector .size-pill:not(.sold-out)') || document.querySelector('#b2cSizeSelector .size-pill');
    if (firstPill) {
      if (typeof window.selectB2CSize === 'function') window.selectB2CSize(firstPill);
      targetVariantId = window.TFI ? window.TFI.selectedSingleVariantId : null;
    }
  }

  if (!targetVariantId) {
    var jsonEl = document.getElementById('pdpProductJson');
    if (jsonEl) {
      try {
        var pData = JSON.parse(jsonEl.textContent);
        if (pData && pData.variants && pData.variants.length > 0) {
          targetVariantId = pData.variants[0].id;
        }
      } catch (e) {}
    }
  }

  if (!targetVariantId) {
    alert('Please select your size before proceeding.');
    return;
  }

  var qtyInput = document.getElementById('singleQtyInput');
  var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
  var buyBtn = document.getElementById('btnSingleBuyNow') || document.getElementById('stickyBuyNowBtn');
  if (buyBtn) {
    buyBtn.textContent = 'Securing Order... 🔒';
    buyBtn.disabled = true;
  }

  var item = {
    id: parseInt(targetVariantId, 10),
    quantity: qty,
    properties: {
      'Purchase Type': 'Single Piece Retail',
      'Selected Garment': (window.TFI && window.TFI.selectedSingleVariantTitle) || 'Standard'
    }
  };

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [item] })
  })
  .then(function() {
    window.location.href = '/checkout';
  })
  .catch(function(err) {
    console.error('Direct checkout add error:', err);
    window.location.href = '/checkout';
  });
};



// ================= 5. QUICK BUY MODAL (HOMEPAGE CARDS) =================
window.closeQuickModal = function(e) {
  if (e && e.target !== e.currentTarget && !e.target.classList.contains('qm-close-btn')) return;
  var modal = document.getElementById('quickBuyModal');
  if (modal) modal.style.display = 'none';
};

window.selectQmSize = function(btn) {
  var pills = document.querySelectorAll('.qm-size-pill');
  pills.forEach(function(p) { p.classList.remove('selected'); });
  btn.classList.add('selected');
};

window.stepQmQty = function(delta) {
  var input = document.getElementById('qmQtyInput');
  if (!input) return;
  var cur = parseInt(input.value, 10) || 1;
  input.value = Math.max(1, cur + delta);
};

window.handleQmAddToCart = function() {
  var selectedPill = document.querySelector('.qm-size-pill.selected');
  if (!selectedPill) {
    alert('Please select a size');
    return;
  }
  var varId = selectedPill.getAttribute('data-variant-id');
  var input = document.getElementById('qmQtyInput');
  var qty = input ? parseInt(input.value, 10) || 1 : 1;
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [{ id: parseInt(varId, 10), quantity: qty }] })
  })
  .then(function() {
    window.closeQuickModal();
    window.openCart();
  });
};

// ================= 6. MOBILE NAVIGATION & REELS =================
window.toggleMobileDrawer = function() {
  var drawer = document.getElementById('mobileNavDrawer') || document.querySelector('.tfi-mob-drawer') || document.querySelector('.mobile-nav-drawer');
  var backdrop = document.getElementById('mobileNavBackdrop') || document.querySelector('.tfi-mob-backdrop');
  if (drawer) {
    var isOpen = drawer.classList.contains('open') || drawer.classList.contains('active');
    if (isOpen) {
      drawer.classList.remove('open', 'active');
      if (backdrop) backdrop.classList.remove('open', 'active');
      document.body.style.overflow = '';
    } else {
      drawer.classList.add('open', 'active');
      if (backdrop) backdrop.classList.add('open', 'active');
      document.body.style.overflow = 'hidden';
    }
  }
};

window.closeMobileDrawer = function() {
  var drawer = document.getElementById('mobileNavDrawer') || document.querySelector('.tfi-mob-drawer') || document.querySelector('.mobile-nav-drawer');
  var backdrop = document.getElementById('mobileNavBackdrop') || document.querySelector('.tfi-mob-backdrop');
  if (drawer) drawer.classList.remove('open', 'active');
  if (backdrop) backdrop.classList.remove('open', 'active');
  document.body.style.overflow = '';
};

window.toggleMobAccordion = function(accId, e) {
  if (e) {
    e.preventDefault();
    e.stopPropagation();
  }
  var acc = document.getElementById(accId);
  if (!acc && typeof accId === 'string') {
    acc = document.querySelector('.' + accId) || document.getElementById('mob-acc-' + accId);
  }
  if (acc) {
    var isCurrentlyOpen = acc.classList.contains('open') || acc.classList.contains('active');
    if (isCurrentlyOpen) {
      acc.classList.remove('open', 'active');
    } else {
      acc.classList.add('open', 'active');
    }
  }
};

window.slideFactoryReels = function(direction) {
  var track = document.getElementById('reelsTrack') || document.querySelector('.reels-slider-track') || document.getElementById('factoryReelsTrack') || document.querySelector('.video-slider-track');
  if (track) {
    var card = track.querySelector('.reel-card');
    var scrollStep = card ? (card.offsetWidth + 20) : 320;
    track.scrollBy({ left: direction * scrollStep, behavior: 'smooth' });
  }
};

window.toggleFjHotspot = function(pin) {
  var card = pin.nextElementSibling;
  var allCards = document.querySelectorAll('.fj-spot-card');
  allCards.forEach(function(c) { if (c !== card) c.classList.remove('active'); });
  if (card) card.classList.toggle('active');
};

// ================= 7. SIZE CHART MODAL =================
window.openSizeChart = function() {
  var m = document.getElementById('sizeChartModal');
  if (m) m.style.display = 'flex';
};

window.closeSizeChart = function(e) {
  if (e && e.target !== e.currentTarget && !e.target.classList.contains('scm-close-btn')) return;
  var m = document.getElementById('sizeChartModal');
  if (m) m.style.display = 'none';
};

window.switchSizeChartCat = function(cat) {
  var tabs = document.querySelectorAll('.scm-tab');
  tabs.forEach(function(t) { t.classList.remove('active'); });
  if (event && event.currentTarget) event.currentTarget.classList.add('active');
  var tables = document.querySelectorAll('.scm-table-group');
  tables.forEach(function(tbl) {
    tbl.style.display = tbl.id === 'table-' + cat ? 'block' : 'none';
  });
};

window.setSizeUnit = function(unit) {
  var btns = document.querySelectorAll('.scm-unit-btn');
  btns.forEach(function(b) { b.classList.remove('active'); });
  if (event && event.currentTarget) event.currentTarget.classList.add('active');
};

// ================= 8. POPUPS, CRO ENGINE & LEAD CAPTURE =================
window.openWelcomeLeadPopup = function() {
  var p = document.getElementById('welcomeLeadPopup');
  var b = document.getElementById('wlpBackdrop');
  if (p) p.classList.add('open');
  if (b) b.classList.add('open');
};

window.closeWelcomeLeadPopup = function() {
  var p = document.getElementById('welcomeLeadPopup');
  var b = document.getElementById('wlpBackdrop');
  if (p) p.classList.remove('open');
  if (b) b.classList.remove('open');
  try {
    sessionStorage.setItem('tfi_welcome_popup_dismissed', 'true');
  } catch(e) {}
};

window.updateWelcomeDiscountCurrency = function(code) {
  var heading = document.getElementById('wlpDiscountHeading');
  var btnTxt = document.getElementById('wlpBtnDiscountText');
  var perk = document.getElementById('wlpPerkText');
  var succTxt = document.getElementById('wlpSuccessDiscountText');

  var isIndia = (code === '+91');
  var discStr = isIndia ? '₹150 OFF' : '10% OFF';
  var perkStr = isIndia ? '✨ Flat ₹150 Coupon' : '✨ 10% Welcome Discount';

  if (heading) heading.textContent = discStr;
  if (btnTxt) btnTxt.textContent = discStr;
  if (perk) perk.textContent = perkStr;
  if (succTxt) succTxt.textContent = discStr;
};

window.handleWelcomeLeadSubmit = function(e) {
  if (e) e.preventDefault();
  var phone = document.getElementById('wlpPhone') ? document.getElementById('wlpPhone').value : '';
  var email = document.getElementById('wlpEmail') ? document.getElementById('wlpEmail').value : '';
  var country = document.getElementById('wlpCountryCode') ? document.getElementById('wlpCountryCode').value : '+91';

  var formContainer = document.getElementById('wlpFormContainer');
  var successState = document.getElementById('wlpSuccessState');

  if (formContainer) formContainer.style.display = 'none';
  if (successState) successState.style.display = 'block';

  try {
    localStorage.setItem('tfi_lead_captured', 'true');
    localStorage.setItem('tfi_lead_phone', country + ' ' + phone);
    localStorage.setItem('tfi_lead_email', email);
    sessionStorage.setItem('tfi_welcome_popup_dismissed', 'true');
  } catch(err) {}

  // Post to contact / newsletter endpoint quietly
  fetch('/contact', {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body: 'form_type=customer&utf8=✓&contact[tags]=Welcome_Lead,VIP_Member&contact[email]=' + encodeURIComponent(email) + '&contact[phone]=' + encodeURIComponent(country + phone)
  }).catch(function() {});
};

window.copyWelcomeCoupon = function() {
  var code = document.getElementById('wlpCouponCode') ? document.getElementById('wlpCouponCode').innerText : 'FACTORY150';
  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(code);
  }
  var badge = document.getElementById('wlpCopyBadge');
  if (badge) {
    badge.innerText = 'COPIED! ✅';
    badge.style.background = '#25D366';
    badge.style.color = '#fff';
  }
};

window.closeB2BLeadModal = function() {
  var m = document.getElementById('b2bLeadModal');
  var b = document.getElementById('b2bModalBackdrop');
  if (m) m.classList.remove('open');
  if (b) b.classList.remove('open');
};

window.openB2BLeadModal = function() {
  var m = document.getElementById('b2bLeadModal');
  var b = document.getElementById('b2bModalBackdrop');
  if (m) m.classList.add('open');
  if (b) b.classList.add('open');
};

window.dismissSocialProofToast = function() {
  var t = document.getElementById('tfiSocialProofToast');
  if (t) t.classList.remove('show');
};

// ================= LIVE ROTATING SOCIAL PROOF ENGINE =================
window.initSocialProofEngine = function() {
  var orders = [
    { name: 'Rajesh from Surat', desc: 'ordered 50 Pcs Ganesh Mandal T-Shirts', time: '2 minutes ago' },
    { name: 'Vikram from Ahmedabad', desc: 'ordered 25 Pcs Lacosta Polos', time: '4 minutes ago' },
    { name: 'Pooja from Mumbai', desc: 'ordered 8 Pcs Bell-Bottom Flared Pants', time: '7 minutes ago' },
    { name: 'Amit from Bengaluru', desc: 'ordered 100 Pcs Luxury Rhinestone Hoodies', time: '11 minutes ago' },
    { name: 'David from London, UK', desc: 'ordered 50 Pcs Silk Blend Festive Kurtas', time: '14 minutes ago' },
    { name: 'Sneha from Delhi', desc: 'ordered 30 Pcs Raglan Athletic Gym Tees', time: '18 minutes ago' },
    { name: 'Rahul from Hyderabad', desc: 'ordered 2-Piece Night Suit Loungewear Set', time: '22 minutes ago' },
    { name: 'Ananya from Pune', desc: 'ordered 15 Pcs Cross-Front Crop Hoodies', time: '27 minutes ago' }
  ];

  var toast = document.getElementById('tfiSocialProofToast');
  var buyerText = document.getElementById('tstBuyerText');
  var timeAgo = document.getElementById('tstTimeAgo');
  if (!toast || !buyerText) return;

  var idx = 0;
  function showNextToast() {
    var order = orders[idx % orders.length];
    buyerText.innerHTML = '<b>' + order.name + '</b> ' + order.desc;
    if (timeAgo) timeAgo.textContent = order.time;
    toast.classList.add('show');

    setTimeout(function() {
      toast.classList.remove('show');
    }, 5500);

    idx++;
  }

  // Initial delay 6s, then repeats every 22s
  setTimeout(function() {
    showNextToast();
    setInterval(showNextToast, 22000);
  }, 6000);
};

// ================= MASTER POPUP AUTO-TRIGGER CONTROLLER =================
window.initMasterPopupTriggers = function() {
  var isDismissed = false;
  var isCaptured = false;
  try {
    isDismissed = sessionStorage.getItem('tfi_welcome_popup_dismissed') === 'true';
    isCaptured = localStorage.getItem('tfi_lead_captured') === 'true';
  } catch(e) {}

  if (!isDismissed && !isCaptured) {
    // 1. INSTANT FIRST VISIT TRIGGER (1 second after page load)
    setTimeout(function() {
      var p = document.getElementById('welcomeLeadPopup');
      if (p && !p.classList.contains('open') && !sessionStorage.getItem('tfi_welcome_popup_dismissed')) {
        window.openWelcomeLeadPopup();
      }
    }, 1200);

    // 2. Desktop Exit Intent fallback
    document.addEventListener('mouseleave', function(e) {
      if (e.clientY <= 15) {
        var p = document.getElementById('welcomeLeadPopup');
        if (p && !p.classList.contains('open') && !sessionStorage.getItem('tfi_welcome_popup_dismissed')) {
          window.openWelcomeLeadPopup();
        }
      }
    });

    // 3. Mobile Scroll Depth Trigger (past 30%)
    var scrollTriggered = false;
    window.addEventListener('scroll', function() {
      if (scrollTriggered) return;
      var scrollPercent = (window.scrollY + window.innerHeight) / document.documentElement.scrollHeight;
      if (scrollPercent > 0.30) {
        scrollTriggered = true;
        var p = document.getElementById('welcomeLeadPopup');
        if (p && !p.classList.contains('open') && !sessionStorage.getItem('tfi_welcome_popup_dismissed')) {
          window.openWelcomeLeadPopup();
        }
      }
    }, { passive: true });
  }

  // Start Social Proof Engine
  window.initSocialProofEngine();
};

// ================= 9. DESIGN CUSTOMIZER STUDIO =================
window.openDesignStudio = function() {
  var s = document.getElementById('designStudioModal');
  if (s) s.style.display = 'flex';
};

window.closeDesignStudio = function() {
  var s = document.getElementById('designStudioModal');
  if (s) s.style.display = 'none';
};

window.setStudioSide = function(side) { window.TFI.studioSide = side; };
window.setStudioMode = function(mode) { window.TFI.studioMode = mode; };
window.setStudioTab = function(tab) { window.TFI.studioTab = tab; };
window.handleStudioArtwork = function(input) { console.log('Artwork selected'); };
window.removeStudioArtwork = function() { window.TFI.currentArtworkUrl = null; };
window.scaleStudioArtwork = function(val) { window.TFI.scale = val; };
window.scaleStudioArtworkDelta = function(d) { window.TFI.scale = (window.TFI.scale || 100) + d; };
window.rotateStudioArtwork = function(d) { window.TFI.rotation = (window.TFI.rotation || 0) + d; };
window.updateStudioText = function() {};
window.setStudioTextColor = function(color) {};
window.applyPlacementPreset = function(preset) { window.TFI.currentPlacement = preset; };
window.centerStudioArtwork = function() { window.TFI.posX = 50; window.TFI.posY = 50; };
window.sendStudioWhatsAppProof = function() { window.open('https://wa.me/918320610394', '_blank'); };
window.applyStudioDesignToOrder = function() { window.closeDesignStudio(); };

// AUTO-INIT ON DOM READY
document.addEventListener('DOMContentLoaded', function() {
  // Auto-init multi option product
  var firstColor = document.querySelector('#colorSelectorGrid button.selected') || document.querySelector('#colorSelectorGrid button');
  var firstSize = document.querySelector('#sizeSelectorGrid button.selected') || document.querySelector('#sizeSelectorGrid button');
  if (firstColor && firstSize && window.selectPdpOption) {
    window.selectPdpOption(firstColor, 0, firstColor.getAttribute('data-option-value') || firstColor.innerText.trim());
  }

  // Auto-init catalog default tab
  if (typeof window.switchCatalogTab === 'function') {
    var defaultPill = document.querySelector('.cat-pill.active, .tfi-cat-pill.active');
    if (defaultPill) {
      var tabAttr = defaultPill.getAttribute('data-tab') || 'bestsellers';
      window.switchCatalogTab(tabAttr, defaultPill);
    }
  }
  if (window.initMasterPopupTriggers) window.initMasterPopupTriggers();
});


// ================= STANDALONE /cart PAGE CONTROLLER =================
window.removeCartItem = function(key) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: 0 })
  }).then(function() {
    window.location.reload();
  });
};

window.changeCartQty = function(key, newQty) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: parseInt(newQty, 10) })
  }).then(function() {
    window.location.reload();
  });
};

// ================= 10. AI FACTORY THINKING ADVISOR CONTROLLER =================
window.selectedAiType = 'D2C Brand';

window.openAiAdvisorModal = function() {
  var m = document.getElementById('aiAdvisorModal');
  var b = document.getElementById('aiAdvisorBackdrop');
  if (m) m.classList.add('open');
  if (b) b.classList.add('open');
};

window.closeAiAdvisorModal = function() {
  var m = document.getElementById('aiAdvisorModal');
  var b = document.getElementById('aiAdvisorBackdrop');
  if (m) m.classList.remove('open');
  if (b) b.classList.remove('open');
};

window.selectAiOption = function(btn, type) {
  var btns = document.querySelectorAll('.ai-opt-btn');
  btns.forEach(function(b) { b.classList.remove('active'); });
  if (btn) btn.classList.add('active');
  window.selectedAiType = btn.getAttribute('data-type') || 'D2C Brand';
};

window.adjustAiQty = function(delta) {
  var input = document.getElementById('aiQtyInput');
  if (input) {
    var val = parseInt(input.value, 10) || 25;
    val = Math.max(10, val + delta);
    input.value = val;
  }
};

window.runAiAdvisorThinking = function() {
  var qStep = document.getElementById('aiStepQuestionnaire');
  var tStep = document.getElementById('aiStepThinking');
  var rStep = document.getElementById('aiStepResult');
  var pFill = document.getElementById('aiProgressFill');
  var statusText = document.getElementById('aiThinkingStatus');
  var detailText = document.getElementById('aiThinkingDetail');

  if (qStep) qStep.style.display = 'none';
  if (tStep) tStep.style.display = 'block';
  if (rStep) rStep.style.display = 'none';

  var statusUpdates = [
    { pct: '25%', title: 'AI is analyzing Surat yarn inventory...', sub: 'Filtering 100% Super Combed Compact yarns...' },
    { pct: '60%', title: 'Calculating optimal GSM weight & shrinkage-control wash...', sub: 'Determining bio-wash & silicon softening parameters...' },
    { pct: '85%', title: 'Synthesizing Tajima embroidery & DTF stitch densities...', sub: 'Optimizing per-unit production cost and direct mill rate...' },
    { pct: '100%', title: 'Specification Generated Successfully!', sub: 'Finalizing factory quote...' }
  ];

  var stepIdx = 0;
  var interval = setInterval(function() {
    if (stepIdx < statusUpdates.length) {
      var item = statusUpdates[stepIdx];
      if (pFill) pFill.style.width = item.pct;
      if (statusText) statusText.textContent = item.title;
      if (detailText) detailText.textContent = item.sub;
      stepIdx++;
    } else {
      clearInterval(interval);
      setTimeout(function() {
        if (tStep) tStep.style.display = 'none';
        if (rStep) rStep.style.display = 'block';
        window.populateAiRecommendation();
      }, 500);
    }
  }, 700);
};

window.populateAiRecommendation = function() {
  var qty = parseInt(document.getElementById('aiQtyInput') ? document.getElementById('aiQtyInput').value : 25, 10);
  var type = window.selectedAiType || 'D2C Brand';

  var resTitle = document.getElementById('aiResultTitle');
  var sFabric = document.getElementById('aiSpecFabric');
  var sCraft = document.getElementById('aiSpecCraft');
  var sPrice = document.getElementById('aiSpecPrice');
  var sTime = document.getElementById('aiSpecTime');

  if (type === 'D2C Brand') {
    if (resTitle) resTitle.textContent = "240 GSM Super Combed Bio-Washed Heavy Cotton";
    if (sFabric) sFabric.textContent = "100% Combed Heavy Cotton (240 GSM)";
    if (sCraft) sCraft.textContent = "High-Density Puff Print / Tajima Embroidery";
    if (sPrice) sPrice.textContent = qty >= 100 ? "₹240 - ₹280 / Pc" : (qty >= 50 ? "₹280 - ₹320 / Pc" : "₹320 - ₹360 / Pc");
    if (sTime) sTime.textContent = "3 to 4 Days Dispatch";
  } else if (type === 'Corporate Uniforms') {
    if (resTitle) resTitle.textContent = "260 GSM Honeycomb Matty Pique Polo";
    if (sFabric) sFabric.textContent = "Luxury Pique Cotton Blend (260 GSM)";
    if (sCraft) sCraft.textContent = "Japanese Tajima Chest Embroidery";
    if (sPrice) sPrice.textContent = qty >= 100 ? "₹260 - ₹290 / Pc" : (qty >= 50 ? "₹290 - ₹340 / Pc" : "₹340 - ₹390 / Pc");
    if (sTime) sTime.textContent = "3 to 5 Days Dispatch";
  } else if (type === 'Festive / Ethnic') {
    if (resTitle) resTitle.textContent = "Jacquard Self-Design Silk Blend Festive Kurta";
    if (sFabric) sFabric.textContent = "Premium Jacquard Silk Blend";
    if (sCraft) sCraft.textContent = "Woven Self-Design + Contrast Buttons";
    if (sPrice) sPrice.textContent = qty >= 100 ? "₹390 - ₹440 / Pc" : "₹450 - ₹520 / Pc";
    if (sTime) sTime.textContent = "2 to 4 Days Dispatch";
  } else {
    if (resTitle) resTitle.textContent = "Moisture-Wicking Raglan Athletic Activewear";
    if (sFabric) sFabric.textContent = "100% Breathable Dry-Fit Polyester";
    if (sCraft) sCraft.textContent = "Sublimation / Reflective Vinyl Print";
    if (sPrice) sPrice.textContent = qty >= 100 ? "₹180 - ₹220 / Pc" : "₹230 - ₹270 / Pc";
    if (sTime) sTime.textContent = "2 to 3 Days Dispatch";
  }
};

window.resetAiAdvisor = function() {
  var qStep = document.getElementById('aiStepQuestionnaire');
  var tStep = document.getElementById('aiStepThinking');
  var rStep = document.getElementById('aiStepResult');
  if (qStep) qStep.style.display = 'block';
  if (tStep) tStep.style.display = 'none';
  if (rStep) rStep.style.display = 'none';
};

window.sendAiQuoteToWhatsApp = function() {
  var qty = document.getElementById('aiQtyInput') ? document.getElementById('aiQtyInput').value : '25';
  var type = window.selectedAiType || 'D2C Brand';
  var fabric = document.getElementById('aiSpecFabric') ? document.getElementById('aiSpecFabric').innerText : '';
  var price = document.getElementById('aiSpecPrice') ? document.getElementById('aiSpecPrice').innerText : '';

  var text = "Hello Tshirt Factory India! 👋 I just ran the AI Factory Advisor on your website:\n\n" +
             "• Type: " + type + "\n" +
             "• Quantity: " + qty + " Pcs\n" +
             "• Recommended Fabric: " + fabric + "\n" +
             "• Estimated Price: " + price + "\n\n" +
             "I would like to proceed with a 100% Free 3D visual proof & factory quote!";

  window.open('https://wa.me/918320610394?text=' + encodeURIComponent(text), '_blank');
};


// ========================================================
// FLAWLESS CART DRAWER ENGINE & CRO UPSELL ENGINE
// ========================================================

window.openCart = function() {
  var drawer = document.getElementById('drawer') || document.getElementById('cartDrawer') || document.querySelector('aside.drawer') || document.querySelector('.drawer');
  var scrim = document.getElementById('scrim') || document.getElementById('cartScrim') || document.querySelector('.scrim');
  
  if (drawer) {
    drawer.classList.add('on', 'open', 'active');
    if (scrim) scrim.classList.add('on', 'open', 'active');
    document.body.classList.add('drawer-open');
    document.body.style.overflow = 'hidden';
    window.updateCartDrawer();
  } else {
    window.location.href = '/cart';
  }
};

window.closeCart = function() {
  var drawer = document.getElementById('drawer') || document.getElementById('cartDrawer') || document.querySelector('aside.drawer') || document.querySelector('.drawer');
  var scrim = document.getElementById('scrim') || document.getElementById('cartScrim') || document.querySelector('.scrim');
  
  if (drawer) {
    drawer.classList.remove('on', 'open', 'active');
  }
  if (scrim) {
    scrim.classList.remove('on', 'open', 'active');
  }
  document.body.classList.remove('drawer-open');
  document.body.style.overflow = '';
};

window.updateCartDrawer = function() {
  fetch('/cart.js', { cache: 'no-store' })
    .then(function(res) { return res.json(); })
    .then(function(cart) {
      window.renderCartDrawer(cart);
    })
    .catch(function(err) {
      console.error('Error fetching cart:', err);
    });
};

window.renderCartDrawer = function(cart) {
  if (!cart) return;

  var countEl = document.getElementById('drawerCount');
  var ditems = document.getElementById('ditems');
  var dfoot = document.getElementById('dfoot');
  var subtotalDisplay = document.getElementById('drawerSubtotalDisplay');
  var fillEl = document.getElementById('dsbProgressFill');
  var msgEl = document.getElementById('dsbMessage');

  // Update header badges with pop feedback
  var countBadges = document.querySelectorAll('.tfi-cart-badge, #count, .cart-count, #cartCount, .count, [data-cart-count]');
  var newCount = (typeof cart.item_count === 'number') ? cart.item_count : (cart.items ? cart.items.reduce(function(sum, it){ return sum + it.quantity; }, 0) : 0);
  countBadges.forEach(function(el) {
    el.textContent = newCount;
    el.classList.remove('pop');
    requestAnimationFrame(function() {
      el.classList.add('pop');
    });
  });

  if (countEl) {
    countEl.textContent = newCount;
  }

  // Free shipping progress bar (Threshold: ₹999)
  var totalInRupees = (cart.total_price || 0) / 100;
  var freeShipThreshold = 999;

  if (fillEl && msgEl) {
    var pct = Math.min(100, Math.round((totalInRupees / freeShipThreshold) * 100));
    fillEl.style.width = pct + '%';
    if (totalInRupees >= freeShipThreshold) {
      msgEl.innerHTML = '🎉 <b>CONGRATULATIONS!</b> You unlocked <b>FREE Express Delivery across India!</b>';
    } else {
      var remaining = Math.round(freeShipThreshold - totalInRupees);
      msgEl.innerHTML = '🚚 Add <b>₹' + remaining.toLocaleString('en-IN') + '</b> more for <b>FREE Surat Express Delivery!</b>';
    }
  }

  if (cart.item_count === 0) {
    if (ditems) {
      ditems.innerHTML = '<div style="padding:48px 16px;text-align:center;color:#94A3B8;">' +
        '<div style="font-size:2.4rem;margin-bottom:12px;">🛍️</div>' +
        '<p style="font-size:1.35rem;font-weight:700;color:#FFFFFF;margin-bottom:6px">Your Cart is Empty</p>' +
        '<p style="font-size:.86rem;color:#64748B;line-height:1.4;">Explore our factory-direct solid polos, festive silk kurtas, and luxury apparel.</p>' +
        '<a href="/collections/mens-clothes" onclick="window.closeCart()" style="display:inline-block;margin-top:18px;padding:11px 24px;background:#1A1815;color:#FAF8F5;border-radius:6px;text-decoration:none;font-size:0.86rem;font-weight:700;letter-spacing:0.04em;">Explore Collection →</a>' +
        '</div>';
    }
    if (dfoot) dfoot.style.display = 'none';
    return;
  }

  if (dfoot) dfoot.style.display = 'block';
  if (subtotalDisplay) {
    subtotalDisplay.textContent = '₹' + Math.round(totalInRupees).toLocaleString('en-IN');
  }

  if (ditems) {
    var html = '';
    cart.items.forEach(function(item, idx) {
      var priceInRupees = Math.round((item.final_price || item.price) / 100);
      var linePrice = Math.round((item.final_line_price || item.line_price) / 100);
      var img = item.featured_image ? item.featured_image.url || item.image : '';
      var variantTitle = item.variant_title || '';
      if (variantTitle === 'Default Title') variantTitle = '';
      var properties = item.properties || {};
      var propsHtml = '';
      for (var p in properties) {
        if (properties[p] && p.indexOf('_') !== 0) {
          propsHtml += '<div class="ditem-prop">' + p + ': ' + properties[p] + '</div>';
        }
      }

      html += '<div class="ditem-card" data-line="' + (idx + 1) + '">' +
        '<div class="ditem-thumb">' +
          (img ? '<img src="' + img + '" alt="' + (item.title || '').replace(/"/g, '&quot;') + '" loading="lazy">' : '<div style="width:100%;height:100%;background:#EEE;"></div>') +
        '</div>' +
        '<div class="ditem-info">' +
          '<div class="ditem-title-row">' +
            '<h5>' + (item.product_title || item.title) + '</h5>' +
            '<button type="button" class="btn-remove-item" onclick="window.changeDrawerItemQty(' + (idx + 1) + ', 0)" aria-label="Remove item">✕</button>' +
          '</div>' +
          (variantTitle ? '<div class="ditem-variant">' + variantTitle + '</div>' : '') +
          propsHtml +
          '<div class="ditem-bottom-row">' +
            '<div class="ditem-stepper">' +
              '<button type="button" onclick="window.changeDrawerItemQty(' + (idx + 1) + ', ' + (item.quantity - 1) + ')" aria-label="Decrease quantity">−</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button type="button" onclick="window.changeDrawerItemQty(' + (idx + 1) + ', ' + (item.quantity + 1) + ')" aria-label="Increase quantity">+</button>' +
            '</div>' +
            '<b class="ditem-price">₹' + linePrice.toLocaleString('en-IN') + '</b>' +
          '</div>' +
        '</div>' +
      '</div>';
    });
    ditems.innerHTML = html;
  }
};

window.changeDrawerItemQty = function(line, qty) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ line: line, quantity: Math.max(0, qty) })
  })
  .then(function(res) { return res.json(); })
  .then(function(cart) {
    window.renderCartDrawer(cart);
  })
  .catch(function(err) {
    console.error('Error updating cart line quantity:', err);
  });
};

window.addUpsellItemToCart = function(productHandle, title, price, sizeSelectId, btnEl) {
  var sizeEl = document.getElementById(sizeSelectId);
  var selectedSize = sizeEl ? sizeEl.value : 'M';
  
  if (btnEl) {
    btnEl.textContent = 'Adding...';
    btnEl.disabled = true;
  }

  fetch('/products/' + productHandle + '.js')
    .then(function(r) { return r.json(); })
    .then(function(prod) {
      var matchingVariant = prod.variants.find(function(v) {
        return v.title.toLowerCase().indexOf(selectedSize.toLowerCase()) !== -1 || v.option1 === selectedSize;
      }) || prod.variants[0];

      if (!matchingVariant) throw new Error('Variant not found');

      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: matchingVariant.id,
          quantity: 1,
          properties: { 'Promo Add-on': 'Deal of the Day' }
        })
      });
    })
    .then(function(res) { return res.json(); })
    .then(function() {
      if (btnEl) {
        btnEl.textContent = '✔ Added!';
        btnEl.style.background = '#25D366';
      }
      window.updateCartDrawer();
      setTimeout(function() {
        if (typeof window.proceedToDirectCheckout === 'function') {
          window.proceedToDirectCheckout();
        } else {
          window.location.href = '/checkout';
        }
      }, 600);
    })
    .catch(function(err) {
      console.error('Upsell add error:', err);
      if (btnEl) {
        btnEl.textContent = '+ ADD TO ORDER';
        btnEl.disabled = false;
      }
      window.proceedToDirectCheckout();
    });
};

window.proceedToDirectCheckout = function() {
  window.location.href = '/checkout';
};


/* ==========================================================================
   NEIL PATEL CRO BLOG RUNTIME (PROGRESS, TOC, FLOATING BAR, SHARING)
   ========================================================================== */

(function(){
  function initNeilPatelBlog() {
    const articleContainer = document.querySelector('.article-container');
    if (!articleContainer) return;

    // 1. Reading Scroll Progress Bar
    const progressBar = document.getElementById('tfi-reading-progress');
    const floatingBar = document.getElementById('articleFloatingBar');

    window.addEventListener('scroll', function(){
      const rect = articleContainer.getBoundingClientRect();
      const totalHeight = rect.height;
      const scrolledPast = -rect.top;
      const percent = Math.min(100, Math.max(0, (scrolledPast / (totalHeight - window.innerHeight * 0.5)) * 100));

      if (progressBar) {
        progressBar.style.width = percent + '%';
      }

      if (floatingBar) {
        if (percent > 15 && percent < 92) {
          floatingBar.classList.add('is-visible');
        } else {
          floatingBar.classList.remove('is-visible');
        }
      }
    }, { passive: true });

    // 2. Auto-Generate Table of Contents (TOC) from H2 and H3
    const contentBody = document.getElementById('articleContentBody');
    const tocContainer = document.getElementById('articleTocContainer');
    const tocList = document.getElementById('articleTocList');

    if (contentBody && tocContainer && tocList) {
      const headings = contentBody.querySelectorAll('h2, h3');
      if (headings.length >= 2) {
        tocList.innerHTML = '';
        headings.forEach((heading, idx) => {
          const text = heading.textContent.trim();
          if (!text) return;

          const anchorId = 'guide-sec-' + (idx + 1);
          heading.id = anchorId;

          const link = document.createElement('a');
          link.href = '#' + anchorId;
          link.className = 'toc-link ' + (heading.tagName.toLowerCase() === 'h3' ? 'toc-link-h3' : 'toc-link-h2');
          link.innerHTML = (heading.tagName.toLowerCase() === 'h2' ? '▸ ' : '• ') + text;

          link.addEventListener('click', function(e){
            e.preventDefault();
            const target = document.getElementById(anchorId);
            if (target) {
              const yOffset = -90;
              const y = target.getBoundingClientRect().top + window.pageYOffset + yOffset;
              window.scrollTo({ top: y, behavior: 'smooth' });
            }
          });

          tocList.appendChild(link);
        });

        tocContainer.style.display = 'block';
      }
    }

    // 3. Social Share Handlers
    window.shareOnWhatsApp = function() {
      const url = encodeURIComponent(window.location.href);
      const text = encodeURIComponent('Check out this custom apparel manufacturing guide from Tshirt Factory India: ' + document.title + ' ' + window.location.href);
      window.open('https://api.whatsapp.com/send?text=' + text, '_blank');
    };

    window.copyArticleLink = function() {
      navigator.clipboard.writeText(window.location.href).then(function(){
        if (window.showToast) {
          window.showToast('📋 Link copied to clipboard!');
        } else {
          alert('Link copied to clipboard!');
        }
      }).catch(function(){
        prompt('Copy this link:', window.location.href);
      });
    };

    window.toggleArticleToc = function() {
      if (tocList) {
        const isHidden = tocList.style.display === 'none';
        tocList.style.display = isHidden ? 'flex' : 'none';
        const icon = document.getElementById('tocToggleIcon');
        if (icon) {
          icon.style.transform = isHidden ? 'rotate(0deg)' : 'rotate(-90deg)';
        }
      }
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNeilPatelBlog);
  } else {
    initNeilPatelBlog();
  }
})();


/* ==========================================================================
   STICKY TOC RUNTIME & SCROLLSPY (DESKTOP + MOBILE)
   ========================================================================== */

(function(){
  function initStickyToc() {
    const contentBody = document.getElementById('articleContentBody');
    if (!contentBody) return;

    const headings = contentBody.querySelectorAll('h2, h3');
    if (headings.length < 2) return;

    const desktopTocContainer = document.getElementById('articleTocContainer');
    const desktopTocList = document.getElementById('articleTocList');
    const mobileTocContainer = document.getElementById('articleTocMobile');
    const mobileTocList = document.getElementById('articleTocListMobile');

    const headingData = [];

    // 1. Index headings and assign anchor IDs
    headings.forEach((heading, idx) => {
      const text = heading.textContent.trim();
      if (!text) return;

      const anchorId = 'guide-sec-' + (idx + 1);
      heading.id = anchorId;
      const isH3 = heading.tagName.toLowerCase() === 'h3';

      headingData.push({ id: anchorId, text, isH3, el: heading });
    });

    // 2. Build Desktop Sticky TOC
    if (desktopTocList) {
      desktopTocList.innerHTML = '';
      headingData.forEach(item => {
        const link = document.createElement('a');
        link.href = '#' + item.id;
        link.className = 'toc-link ' + (item.isH3 ? 'toc-link-h3' : 'toc-link-h2');
        link.setAttribute('data-target', item.id);
        link.innerHTML = (item.isH3 ? '• ' : '▸ ') + item.text;

        link.addEventListener('click', function(e){
          e.preventDefault();
          const target = document.getElementById(item.id);
          if (target) {
            const yOffset = -100;
            const y = target.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({ top: y, behavior: 'smooth' });
          }
        });

        desktopTocList.appendChild(link);
      });
      if (desktopTocContainer) desktopTocContainer.style.display = 'block';
    }

    // 3. Build Mobile TOC
    if (mobileTocList) {
      mobileTocList.innerHTML = '';
      headingData.forEach(item => {
        const link = document.createElement('a');
        link.href = '#' + item.id;
        link.className = 'toc-link ' + (item.isH3 ? 'toc-link-h3' : 'toc-link-h2');
        link.innerHTML = (item.isH3 ? '• ' : '▸ ') + item.text;

        link.addEventListener('click', function(e){
          e.preventDefault();
          const target = document.getElementById(item.id);
          if (target) {
            const yOffset = -90;
            const y = target.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({ top: y, behavior: 'smooth' });
            // Collapse mobile TOC after jump
            mobileTocList.style.display = 'none';
            const icon = document.getElementById('tocToggleIconMobile');
            if (icon) icon.style.transform = 'rotate(-90deg)';
          }
        });

        mobileTocList.appendChild(link);
      });
      if (mobileTocContainer) mobileTocContainer.style.display = 'block';
    }

    // 4. ScrollSpy (Active Section Tracking)
    const desktopLinks = desktopTocList ? desktopTocList.querySelectorAll('.toc-link') : [];

    let scrollSpyTicking = false;
    window.addEventListener('scroll', function(){
      if (!scrollSpyTicking) {
        window.requestAnimationFrame(function() {
          let currentActiveId = '';
          const scrollY = window.pageYOffset;

          headingData.forEach(item => {
            const top = item.el.getBoundingClientRect().top + scrollY - 140;
            if (scrollY >= top) {
              currentActiveId = item.id;
            }
          });
          scrollSpyTicking = false;
        });
        scrollSpyTicking = true;
      }
    }, { passive: true });
    return; // Bypass original inner function body
    window.addEventListener('_old_scroll', function(){

      if (!currentActiveId && headingData.length > 0) {
        currentActiveId = headingData[0].id;
      }

      desktopLinks.forEach(link => {
        if (link.getAttribute('data-target') === currentActiveId) {
          link.classList.add('is-active');
        } else {
          link.classList.remove('is-active');
        }
      });
    }, { passive: true });

    // 5. Mobile Toggle Function
    window.toggleArticleToc = function(mode) {
      if (mode === 'mobile' && mobileTocList) {
        const isHidden = mobileTocList.style.display === 'none';
        mobileTocList.style.display = isHidden ? 'flex' : 'none';
        const icon = document.getElementById('tocToggleIconMobile');
        if (icon) icon.style.transform = isHidden ? 'rotate(0deg)' : 'rotate(-90deg)';
      }
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyToc);
  } else {
    initStickyToc();
  }
})();


/* ==========================================================================
   STICKY SIDEBAR TOC RUNTIME & SCROLLSPY (SIDEBAR ONLY)
   ========================================================================== */

(function(){
  function initStickySidebarOnly() {
    const contentBody = document.getElementById('articleContentBody');
    if (!contentBody) return;

    const headings = contentBody.querySelectorAll('h2, h3');
    if (headings.length < 2) return;

    const desktopTocContainer = document.getElementById('articleTocContainer');
    const desktopTocList = document.getElementById('articleTocList');
    const headingData = [];

    // 1. Index headings and assign anchor IDs
    headings.forEach((heading, idx) => {
      const text = heading.textContent.trim();
      if (!text) return;

      const anchorId = 'guide-sec-' + (idx + 1);
      heading.id = anchorId;
      const isH3 = heading.tagName.toLowerCase() === 'h3';

      headingData.push({ id: anchorId, text, isH3, el: heading });
    });

    // 2. Build Sticky Sidebar TOC
    if (desktopTocList) {
      desktopTocList.innerHTML = '';
      headingData.forEach(item => {
        const link = document.createElement('a');
        link.href = '#' + item.id;
        link.className = 'toc-link ' + (item.isH3 ? 'toc-link-h3' : 'toc-link-h2');
        link.setAttribute('data-target', item.id);
        link.innerHTML = (item.isH3 ? '• ' : '▸ ') + item.text;

        link.addEventListener('click', function(e){
          e.preventDefault();
          const target = document.getElementById(item.id);
          if (target) {
            const yOffset = -100;
            const y = target.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({ top: y, behavior: 'smooth' });
          }
        });

        desktopTocList.appendChild(link);
      });
      if (desktopTocContainer) desktopTocContainer.style.display = 'block';
    }

    // 3. ScrollSpy (Active Section Tracking)
    const desktopLinks = desktopTocList ? desktopTocList.querySelectorAll('.toc-link') : [];

    window.addEventListener('scroll', function(){
      let currentActiveId = '';
      const scrollY = window.pageYOffset;

      headingData.forEach(item => {
        const top = item.el.getBoundingClientRect().top + scrollY - 140;
        if (scrollY >= top) {
          currentActiveId = item.id;
        }
      });

      if (!currentActiveId && headingData.length > 0) {
        currentActiveId = headingData[0].id;
      }

      desktopLinks.forEach(link => {
        if (link.getAttribute('data-target') === currentActiveId) {
          link.classList.add('is-active');
        } else {
          link.classList.remove('is-active');
        }
      });
    }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickySidebarOnly);
  } else {
    initStickySidebarOnly();
  }
})();


/* ==========================================================================
   STATS HUB INTERACTIVE RUNTIME (SEARCH, FILTERING, CITATION & SHARING)
   ========================================================================== */

(function(){
  function initStatsHub() {
    const searchInput = document.getElementById('statsSearchInput');
    const clearBtn = document.getElementById('statsSearchClear');
    const filterTabs = document.getElementById('statsFilterTabs');
    const cardsGrid = document.getElementById('statsCardsGrid');
    const countDisplay = document.getElementById('statsResultsCount');
    const noResults = document.getElementById('statsNoResults');

    if (!cardsGrid) return;

    const cards = Array.from(cardsGrid.querySelectorAll('.stat-card'));
    let currentCategory = 'all';
    let currentQuery = '';

    function filterStats() {
      let visibleCount = 0;

      cards.forEach(card => {
        const category = card.getAttribute('data-category');
        const keywords = (card.getAttribute('data-keywords') || '') + ' ' + card.innerText.toLowerCase();
        
        const matchesCategory = currentCategory === 'all' || category === currentCategory;
        const matchesSearch = !currentQuery || keywords.toLowerCase().includes(currentQuery.toLowerCase());

        if (matchesCategory && matchesSearch) {
          card.style.display = 'flex';
          visibleCount++;
        } else {
          card.style.display = 'none';
        }
      });

      if (countDisplay) {
        countDisplay.innerHTML = 'Showing <strong>' + visibleCount + '</strong> verified apparel benchmark' + (visibleCount === 1 ? '' : 's');
      }

      if (noResults) {
        noResults.style.display = visibleCount === 0 ? 'block' : 'none';
      }
    }

    if (searchInput) {
      searchInput.addEventListener('input', function(e){
        currentQuery = e.target.value.trim();
        if (clearBtn) clearBtn.style.display = currentQuery ? 'block' : 'none';
        filterStats();
      });
    }

    window.clearStatsSearch = function() {
      if (searchInput) {
        searchInput.value = '';
        currentQuery = '';
      }
      if (clearBtn) clearBtn.style.display = 'none';
      filterStats();
    };

    if (filterTabs) {
      const tabBtns = filterTabs.querySelectorAll('.tab-btn');
      tabBtns.forEach(btn => {
        btn.addEventListener('click', function(){
          tabBtns.forEach(b => b.classList.remove('active'));
          btn.classList.add('active');
          currentCategory = btn.getAttribute('data-category');
          filterStats();
        });
      });
    }

    window.resetAllStatsFilters = function() {
      if (searchInput) searchInput.value = '';
      currentQuery = '';
      if (clearBtn) clearBtn.style.display = 'none';

      if (filterTabs) {
        const tabBtns = filterTabs.querySelectorAll('.tab-btn');
        tabBtns.forEach(b => b.classList.remove('active'));
        const allBtn = filterTabs.querySelector('[data-category="all"]');
        if (allBtn) allBtn.classList.add('active');
      }
      currentCategory = 'all';
      filterStats();
    };

    window.copyStatCitation = function(buttonEl, statText) {
      const citation = '"' + statText + '" — Source: Tshirt Factory India 2026 Manufacturing Benchmark Report (https://www.tshirtfactoryindia.com/pages/manufacturing-stats)';
      navigator.clipboard.writeText(citation).then(function(){
        const origText = buttonEl.innerHTML;
        buttonEl.innerHTML = '✅ Copied!';
        setTimeout(function(){
          buttonEl.innerHTML = origText;
        }, 2000);
      }).catch(function(){
        prompt('Copy citation:', citation);
      });
    };

    window.shareStatOnWA = function(statText) {
      const text = encodeURIComponent('📊 Apparel Manufacturing Insight: ' + statText + '\n\nRead all 2026 benchmarks here: https://www.tshirtfactoryindia.com/pages/manufacturing-stats');
      window.open('https://api.whatsapp.com/send?text=' + text, '_blank');
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStatsHub);
  } else {
    initStatsHub();
  }
})();


  // Auto-init measurement preview on page load
  try {
    var initSizeBtn = document.querySelector('#sizeSelectorGrid button.selected') ||
                      document.querySelector('#b2cSizeSelector button.selected') ||
                      document.querySelector('.size-pill.selected');
    if (initSizeBtn) {
      var initialVal = initSizeBtn.getAttribute('data-option-value') || initSizeBtn.getAttribute('data-variant-title') || initSizeBtn.innerText.trim();
      window.updatePdpDynamicSpecBadge(initialVal);
    }
  } catch(e) {}



// ================= AUTOMATIC DARK THEME CARD & TEXT SANITIZER =================
(function() {
  function sanitizeDarkPages() {
    var containers = document.querySelectorAll('.page-content, .rte, .page-container, .main-page, .shopify-policy__container');
    if (!containers || containers.length === 0) return;

    containers.forEach(function(c) {
      // 1. Sanitize all boxes / cards with light inline backgrounds
      var allDivs = c.querySelectorAll('div, section, article, p, table, tr, td');
      allDivs.forEach(function(el) {
        var bg = el.style.backgroundColor || el.style.background || '';
        if (bg.includes('249') || bg.includes('255') || bg.includes('rgb(250') || bg.includes('white') || bg.includes('#fff') || bg.includes('#FAF') || bg.includes('#f9') || bg.includes('#f5')) {
          el.style.backgroundColor = '#181818';
          el.style.borderColor = '#2A2A2A';
          el.style.color = '#CBD5E1';
        }
        var color = el.style.color || '';
        if (color === 'rgb(34, 34, 34)' || color === 'rgb(85, 85, 85)' || color === 'rgb(0, 0, 0)' || color.includes('#222') || color.includes('#555') || color.includes('#333') || color.includes('#000')) {
          if (el.tagName === 'A') {
            el.style.color = '#FFB300';
          } else {
            el.style.color = '#CBD5E1';
          }
        }
      });

      // 2. Ensure headings inside cards are pure white
      var headings = c.querySelectorAll('h1, h2, h3, h4, h5, h6');
      headings.forEach(function(h) {
        h.style.color = '#FFFFFF';
        h.style.fontWeight = '700';
      });
    });
  }

  function scheduleSanitize() {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(sanitizeDarkPages, { timeout: 3000 });
    } else {
      setTimeout(sanitizeDarkPages, 1200);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleSanitize);
  } else {
    scheduleSanitize();
  }
})();



// ================= BULLETPROOF ABOUT PAGE & RICH TEXT SANITIZER =================
(function() {
  function fixAllPageBoxes() {
    // 1. Target all specific cards
    var darkSelectors = ['.intl-fears', '.tcard', '.factory-address', '.problem-bar', '.value-card', '.founder-box', '.cta-box'];
    darkSelectors.forEach(function(sel) {
      document.querySelectorAll(sel).forEach(function(el) {
        el.style.setProperty('background', '#181818', 'important');
        el.style.setProperty('background-color', '#181818', 'important');
        el.style.setProperty('color', '#CBD5E1', 'important');
      });
    });

    // 2. Target fear box & testimonials specifically
    document.querySelectorAll('.intl-fears h3').forEach(function(h) {
      h.style.setProperty('color', '#FFB300', 'important');
    });
    document.querySelectorAll('.tcard .stars').forEach(function(s) {
      s.style.setProperty('color', '#FFB300', 'important');
    });
    document.querySelectorAll('.tcard .tquote').forEach(function(q) {
      q.style.setProperty('color', '#E2E8F0', 'important');
    });
    document.querySelectorAll('.tcard .tname').forEach(function(n) {
      n.style.setProperty('color', '#FFFFFF', 'important');
    });
    document.querySelectorAll('.factory-address').forEach(function(fa) {
      fa.style.setProperty('background', '#181818', 'important');
      fa.style.setProperty('color', '#E2E8F0', 'important');
      fa.style.setProperty('border-color', 'rgba(255,107,53,0.4)', 'important');
    });
  }

  function scheduleFixAll() {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(fixAllPageBoxes, { timeout: 3500 });
    } else {
      setTimeout(fixAllPageBoxes, 1500);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleFixAll);
  } else {
    scheduleFixAll();
  }
})();



// ================= BULLETPROOF SCROLL & CHECKOUT HELPERS =================
window.scrollToSection = function(sectionId, e) {
  if (e) {
    e.preventDefault();
  }
  var el = document.getElementById(sectionId);
  if (el) {
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  } else {
    window.location.href = '/#' + sectionId;
  }
};

window.proceedToCheckout = function(e) {
  if (e) {
    if (typeof e.preventDefault === 'function') e.preventDefault();
    if (typeof e.stopPropagation === 'function') e.stopPropagation();
  }
  var btn = document.getElementById('goPay') || document.querySelector('.df-checkout-btn');
  if (btn) {
    btn.innerHTML = 'Securing Checkout... 🔒';
    btn.style.opacity = '0.85';
    btn.style.pointerEvents = 'none';
  }
  window.location.href = '/checkout';
};

window.triggerPreCheckoutUpsell = window.proceedToCheckout;
window.proceedToDirectCheckout = window.proceedToCheckout;

// Attach click listener directly to checkout button on DOM load
document.addEventListener('DOMContentLoaded', function() {
  var payBtn = document.getElementById('goPay') || document.querySelector('.df-checkout-btn');
  if (payBtn) {
    payBtn.addEventListener('click', window.proceedToCheckout);
  }
});



// ================= PDP STICKY BOTTOM BUY BAR CONTROLLER =================
(function() {
  function initStickyBuyBar() {
    var stickyBar = document.getElementById('pdpStickyBuyBar');
    var buyBtn = document.getElementById('btnSingleAddToCart') || document.getElementById('buyBoxSection');
    if (!stickyBar || !buyBtn) return;

    var ticking = false;
    function checkSticky() {
      var rect = buyBtn.getBoundingClientRect();
      if (rect.bottom < 80) {
        stickyBar.classList.add('visible');
      } else {
        stickyBar.classList.remove('visible');
      }
      ticking = false;
    }

    window.addEventListener('scroll', function() {
      if (!ticking) {
        window.requestAnimationFrame(checkSticky);
        ticking = true;
      }
    }, { passive: true });

    checkSticky();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyBuyBar);
  } else {
    initStickyBuyBar();
  }
  window.addEventListener('load', initStickyBuyBar);
})();



// AUTO SYNC CART COUNT ON LOAD (DOM, Window Load & Safari/Chrome PageShow Cache)
(function() {
  function syncLiveCart() {
    if (typeof window.updateCartDrawer === 'function') {
      window.updateCartDrawer();
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncLiveCart);
  } else {
    syncLiveCart();
  }
  window.addEventListener('load', syncLiveCart);
  window.addEventListener('pageshow', syncLiveCart);
  document.addEventListener('shopify:section:load', syncLiveCart);
})();
